export const environment = {
    production: true,
    apiUrl: '/api',
    azureClientId: 'f7a9c863-ad0f-4dc2-bf72-f215b0e831f8',
    azureTenantId: '0e0968dd-caa1-4291-a16a-3791e806cbbf',
    redirectUri: 'https://nucleus-test.noblesg.com/home',
};
